import api from '@api';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { DhlServicePoint } from 'skladon-types';
import { DhlServicePointsSearchPayload } from 'src/types/dhlServicePoints';
import {
    getDhlServicePointsFetchSuccess,
    getDhlServicePointsFetchFailure,
    getDhlServicePointByIdFetchSuccess,
    getDhlServicePointByIdFetchFailure,
} from './reducer';

const getDhlServicePointsFetchRequest = async (payload: DhlServicePointsSearchPayload) => {
    const params = new URLSearchParams({
        country: payload.country,
    });
    if (payload.postalCode) {
        params.set('postalCode', payload.postalCode);
    }
    if (payload.city) {
        params.set('city', payload.city);
    }
    if (payload.street) {
        params.set('street', payload.street);
    }
    if (payload.latitude !== undefined) {
        params.set('latitude', String(payload.latitude));
    }
    if (payload.longitude !== undefined) {
        params.set('longitude', String(payload.longitude));
    }
    const res = await api('get', `api/secure/shippers/dhl/service-points?${params.toString()}`);
    return res.data;
};

function* getDhlServicePointsFetch(action: {
    payload: DhlServicePointsSearchPayload;
    type: string;
}): Generator {
    const merge = Boolean(action.payload.merge);
    try {
        const response = (yield call(getDhlServicePointsFetchRequest, action.payload)) as DhlServicePoint[];
        yield put(
            getDhlServicePointsFetchSuccess({
                points: Array.isArray(response) ? response : [],
                merge,
            })
        );
    } catch (error) {
        yield put(getDhlServicePointsFetchFailure({ merge }));
    }
}

export function* getDhlServicePointsFetchWatch() {
    // Map pan sends frequent merge requests – keep only the latest in-flight search
    yield takeLatest('dhlServicePoints/getDhlServicePointsFetch', getDhlServicePointsFetch);
}

const getDhlServicePointByIdFetchRequest = async (servicePointId: string) => {
    const res = await api('get', `api/secure/shippers/dhl/service-point/${encodeURIComponent(servicePointId)}`);
    return res.data;
};

function* getDhlServicePointByIdFetch(action: { type: string; payload: string }): Generator {
    try {
        const response = (yield call(getDhlServicePointByIdFetchRequest, action.payload)) as DhlServicePoint;
        yield put(getDhlServicePointByIdFetchSuccess(response));
    } catch (error) {
        yield put(getDhlServicePointByIdFetchFailure());
    }
}

export function* getDhlServicePointByIdFetchWatch() {
    yield takeEvery('dhlServicePoints/getDhlServicePointByIdFetch', getDhlServicePointByIdFetch);
}
